import { CustomIconProps } from './art';

export const ShareLevoIcon = ({
  height,
  width,
}: CustomIconProps): JSX.Element => (
  <svg
    width={width ? width : '32'}
    height={height ? height : '32'}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="shareLevo"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect width="32" height="32" rx="4" fill="white" />
    </mask>
    <g mask="url(#shareLevo)">
      <rect width="32" height="32" fill="#259BE9" />
      <path
        d="M6.47587 13.516C5.91361 17.1024 5.84936 20.7583 6.28439 24.3606C6.31294 24.5974 6.37425 24.8751 6.60562 24.97C6.83153 25.0626 7.0839 24.9239 7.28 24.7837C8.55484 23.8723 9.54037 22.6514 10.4537 21.411C11.4959 19.9947 12.5062 18.3797 12.3122 16.6638C12.2647 16.2462 12.0728 15.7651 11.6403 15.6721C11.1045 15.5565 10.6884 16.1115 10.5083 16.6026C10.1379 17.6109 10.0501 18.7106 10.2563 19.7603C10.4142 20.5628 10.9307 21.4694 11.7932 21.4861C12.5637 21.5008 13.1092 20.796 13.4648 20.1496C14.3761 18.4937 14.9648 16.1588 15.2335 14.3098C15.4922 15.4762 16.3614 17.1163 16.9551 17.9852C17.0437 18.1151 17.2503 18.2152 17.3734 18.1139C17.4149 18.0793 17.4351 18.0281 17.4536 17.9784C17.6526 17.4468 18.6255 14.0603 18.7301 12.6558C19.3747 12.4485 19.934 12.0118 20.2712 11.4524C20.0045 12.5859 20.0196 13.9212 20.9015 14.7289C21.1463 14.953 21.4578 15.1258 21.7975 15.1528C22.4984 15.2085 23.0825 14.6538 23.4558 14.0897C24.2767 12.8493 24.6147 11.3293 24.3917 9.88113C24.3233 9.43695 24.1986 8.9884 23.9235 8.62249C23.6485 8.25659 23.1996 7.98404 22.7255 8.00073C22.013 8.02576 21.4881 8.66779 21.2798 9.31339C21.0845 9.91847 21.1148 10.6658 21.6262 11.0734C22.2695 11.5863 23.2529 11.2844 23.979 10.8819C25.0027 10.3138 25.6658 9.35153 26 8.27407"
        stroke="white"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
